import React, { Component, useState } from "react";
import Stats from "./Stats";
import Units from "./Units";
import FearGreed from "./FearGreed";
import { TxFee } from "./TxFee";
import Dominance from "./Dominance";
import Addresses from "./Addresses";
import { LNStats } from "./LNStats";
import { Wallets } from "./Wallets";
import Halving from "./Halving";

export class Home extends Component {
  static displayName = Home.name;

  render() {
    return (
      <>
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <Stats />
            </div>
            <div className="col-md-4">
              <Units />
            </div>
            <div className="col-md-4">
              <FearGreed />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <TxFee />
            </div>
            <div className="col-md-4">
              <Dominance />
            </div>
            <div className="col-md-4">
              <Addresses />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <LNStats />
            </div>
            <div className="col-md-4">
              <Halving />
            </div>
            <div className="col-md-4">
              <Wallets />
            </div>
          </div>
        </div>
      </>
    );
  }
}
